import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, Star, TrendingUp, RefreshCw } from "lucide-react";

const ErrorAlert = ({ message }) => {
    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <div className="flex flex-col justify-center items-center min-h-screen px-4">
            {/* Brand Logo */}
            <div className="flex items-center gap-2 mb-6">
                <Star className="h-8 w-8 text-warning fill-current" />
                <h1 className="text-h2 font-bold tracking-tight text-foreground">
                    PremiereLens
                </h1>
                <TrendingUp className="h-8 w-8 text-success" />
            </div>

            {/* Error Card */}
            <div className="max-w-md w-full rounded-xl border border-destructive bg-destructive/10 p-6 text-center">
                <AlertCircle className="h-16 w-16 mx-auto mb-4 text-destructive" />

                <h2 className="text-h4 font-semibold mb-3 text-destructive">
                    Unable to Load Content
                </h2>

                <p className="mb-6 leading-relaxed text-destructive/80">
                    {message || "We're having trouble connecting to our content sources. This might be due to network issues or temporary service unavailability."}
                </p>

                <button
                    onClick={handleRetry}
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-medium transition-colors bg-destructive hover:bg-destructive/90 text-destructive-foreground"
                >
                    <RefreshCw className="h-4 w-4" />
                    Try Again
                </button>
            </div>

            {/* Help Text */}
            <div className="mt-8 text-center max-w-md">
                <p className="text-body-small text-muted-foreground">
                    If this problem persists, please check your internet connection and try again in a few minutes.
                </p>
            </div>
        </div>
    );
};

ErrorAlert.propTypes = {
    message: PropTypes.string
};

export default ErrorAlert;
